// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"27d8076b","814":"5ffe3c3c","901":"74f5b330","918":"42259f33"}[chunkId] + ".chunk.js";
};